import ReactDOM from 'react-dom';
import React from 'react';
import { Provider } from 'react-redux';
import { ThemeProvider } from 'styled-components';
import brightworldTheme from '@codex-brightworld/themes';
import PriceMatch from './PriceMatch';
import uiLocale from '../../../utils/UILocale';

const translations = {
  title: uiLocale.getString('component.priceMatch.title'),
  header: uiLocale.getString('component.priceMatch.header'),
  text: uiLocale.getString('component.priceMatch.text'),
  link: uiLocale.getString('component.priceMatch.link')
};

export default function initPriceMatch(mountEl) {
  ReactDOM.render(
    <Provider store={window.appState}>
      <ThemeProvider theme={brightworldTheme.brightworld}>
        <PriceMatch translations={translations} />
      </ThemeProvider>
    </Provider>, mountEl
  );
}
